import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentId", "parentPlaylistId", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboardField from '../CopyToClipboardField';
import { jsx as _jsx } from "react/jsx-runtime";
function getContentShareLink(_ref) {
  var contentId = _ref.contentId,
    parentPlaylistId = _ref.parentPlaylistId,
    type = _ref.type;
  var base = window.location.origin;
  if (type === 'playlist') {
    return "".concat(base, "/playlists/").concat(contentId);
  }
  if (parentPlaylistId) {
    return "".concat(base, "/playlists/").concat(parentPlaylistId, "?asset=").concat(contentId);
  }
  return "".concat(base, "/assets/").concat(contentId);
}
function ShareableLinkField(_ref2) {
  var contentId = _ref2.contentId,
    parentPlaylistId = _ref2.parentPlaylistId,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'asset' : _ref2$type,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var link = getContentShareLink({
    contentId: contentId,
    parentPlaylistId: parentPlaylistId,
    type: type
  });
  return /*#__PURE__*/_jsx(CopyToClipboardField, _objectSpread({
    value: link,
    label: t('form_shareable_link'),
    description: t('hint_content_shareable_link'),
    maxFieldWidth: 400
  }, otherProps));
}
export default ShareableLinkField;